import React, { Component } from 'react';
import Row from '../basic/row';
import { Icon, Button } from 'antd';
import Container from './Container';
import SvgIcon from 'SvgIcon';
import { proxy } from 'yxyweb/common/helpers/util';
import BatchMsg from './batchMsg';

export default class Workbench extends Component {
  constructor (props) {
    super(props);
    const { viewModel } = this.props;
    const dimensionKeys = []; let groupCode = ''; let billNo = ''; let groupTaskKey;
    if (viewModel) {
      viewModel.setCache('isInWorkBench', true);
      const keys = viewModel.getParams().dimensionKeys;
      keys && keys.map((obj, index) => {
        let cacheData = null;
        if (index == 0) {
          cacheData = viewModel.getParams().targetData;
        }
        dimensionKeys.push({
          key: obj.key, name: obj.name, isComplete: false, cacheData: cacheData, errInfo: null
        });
      });
      groupCode = viewModel.getParams().dimensionGroupCode;
      billNo = viewModel.getParams().billNo;
      groupTaskKey = viewModel.getParams().groupTaskKey;
    }
    else {
      this.consoleLog('生单工作台传入参数中没有viewModel！ ', true);
    }
    this.state = {
      viewModel: viewModel,
      dimensionKeys: dimensionKeys,
      focusRowIndex: -1,
      groupCode: groupCode,
      billNo: billNo,
      addData: {},
      showModal: false,
      navActive: 0,
      groupTaskKey,
    };
    this.isEnd = false;
    this.initData(viewModel, billNo);
    this.nowKeyIndex = 0;

    this.isTest = false;
  }

  initData = (viewModel, billNo) => {
    viewModel.on('afterSave', (saveData, callback) => {
      this.afterSingleSave(saveData, callback);
    });
    const postData = { billnum: billNo };
    const params = this.state.viewModel.getParams();
    const carryParams = params.carryParams || {};
    Object.assign(postData, carryParams);
    this.getAddData(postData);
  }

  async getAddData (params) {
    const config = { url: '/bill/add', method: 'POST', options: { token: true }, params: params };
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('调用add失败:' + json.message, 'error');
      return;
    }
    this.setState({ addData: json.data });
  }

  onMouseEnter = (e, index) => {
    this.setState({ focusRowIndex: index });
  }

  saveAll = () => {
    const { viewModel, addData, dimensionKeys } = this.state;
    this.setCacheData(dimensionKeys, viewModel, this.nowKeyIndex);
    if(dimensionKeys[0].isComplete == false) this.nowKeyIndex = 0;
    this.isEnd = false;
    viewModel.clear();
    dimensionKeys.forEach((obj, index) => {
      if (!obj.isComplete) {
        obj.errInfo = null;
      }
    });
    // viewModel.loadData(Object.assign({}, addData, dimensionKeys[this.nowKeyIndex].cacheData));
    viewModel.biz.do('render', viewModel, { data: Object.assign({}, addData, dimensionKeys[this.nowKeyIndex].cacheData), dirty: true });
    viewModel.setCache('isHideAlert', true);
    this.setState({ viewModel });
    // this.setState({ showModal: true, viewModel });
    this.loopSave();
  }

  loopSave = () => {
    const { billNo, viewModel } = this.state;
    const saveAction = viewModel.biz.action().save;
    var params = viewModel.getParams();
    params = cb.utils.extend(true, {}, params);
    params.beforeSaveErrCallBack = (err) => {
      if (!this.state.showModal) this.setState({ showModal: true });
      this.afterSave({ err: { message: err } }, true);
    };
    // let before
    saveAction(billNo,
      viewModel,
      params,
      (beforeActData, callback) => {
        return viewModel.promiseExecute('beforeSave', beforeActData, () => {
          if (!this.state.showModal) this.setState({ showModal: true });
          if (params && params.disabledCallback)
            params.disabledCallback();
          callback && callback();
        });
      },
      (afterActData, callback) => {
        this.afterSave(afterActData, true);
        if (params && params.enabledCallback)
          params.enabledCallback();
        afterActData.saveAll = true;
        return viewModel.promiseExecute('afterSave', afterActData, function () {
          callback && callback(afterActData)
        });
      });
  }

  setCacheData (dimensionKeys, viewModel, index) {
    const data = viewModel.collectData(true);
    data.dimensionKey = dimensionKeys[index].key;
    dimensionKeys[index].cacheData = data;
  }

  afterSingleSave = (afterActData) => {
    if(afterActData.saveAll) return;
    const { dimensionKeys, groupCode, viewModel } = this.state;
    if (afterActData.err && this.isTest == false) {
      dimensionKeys[this.nowKeyIndex].isComplete = false;
      dimensionKeys[this.nowKeyIndex].errInfo = afterActData.err;
      this.setCacheData(dimensionKeys, viewModel, this.nowKeyIndex);
    } else {
      dimensionKeys[this.nowKeyIndex].isComplete = true;
      const noCompleteKeys = [];
      dimensionKeys.forEach((dimensionKey, i) => {
        if(dimensionKey.isComplete == false)
          noCompleteKeys.push(i);
      });
      if (noCompleteKeys.length == 0) {
        this.goBack(groupCode, viewModel, true);
        return;
      } else {
        let index = -1; const len = noCompleteKeys.length - 1;
        index = noCompleteKeys.findIndex(i => {
          return i > this.nowKeyIndex && !dimensionKeys[i].isComplete;
        })
        if(index == len || index == -1) {
          this.nowKeyIndex = noCompleteKeys[0];
        }else{
          this.nowKeyIndex = noCompleteKeys[index + 1];
        }
      }
      const obj = dimensionKeys[this.nowKeyIndex];
      this.onDimensionClick(null, obj.key, false, this.nowKeyIndex, false);
    }
    this.setState({ dimensionKeys })
  }

  afterSave = (afterActData, bLoopSave) => {
    const { dimensionKeys, viewModel } = this.state;
    const noCompleteKeys = []; let bError = false; let needLoop = true;
    if (afterActData.err) {
      bError = true;
      dimensionKeys[this.nowKeyIndex].isComplete = false;
      dimensionKeys[this.nowKeyIndex].errInfo = afterActData.err;
      this.setCacheData(dimensionKeys, viewModel, this.nowKeyIndex);
    } else {
      if(afterActData.res && afterActData.res.code) {
        if (dimensionKeys[this.nowKeyIndex].cacheData)
          dimensionKeys[this.nowKeyIndex].cacheData.code = afterActData.res.code;
        else
          dimensionKeys[this.nowKeyIndex].cacheData = afterActData.res;
      }
      if (dimensionKeys.length > 0) dimensionKeys[this.nowKeyIndex].isComplete = true;
    }
    dimensionKeys.forEach((dimensionKey, index) => {
      if(dimensionKey.isComplete == false)
        noCompleteKeys.push(index);
    });
    if(noCompleteKeys.length == 0) {
      this.isEnd = true;
      if (bLoopSave !== true) {
        this.nowKeyIndex = 0;
        this.setState({ navActive: this.nowKeyIndex, showModal: true });
      }
      if(this.state.showModal == false && this.checkReturn()) viewModel.communication({ type: 'return' });
    }else{
      let index = -1; const len = noCompleteKeys.length - 1;
      index = noCompleteKeys.findIndex(i => {
        return i == this.nowKeyIndex;
      })
      if (bError) {
        if (len == -1 || index == -1 || index == len) {
          this.nowKeyIndex = noCompleteKeys[0];
          needLoop = false;
        } else {
          this.nowKeyIndex = noCompleteKeys[index + 1];
        }
      } else {
        if (len == -1 || index == len) {
          this.nowKeyIndex = noCompleteKeys[0];
          needLoop = false;
        } else {
          var nextIndex = noCompleteKeys.findIndex(i => {
            return i > this.nowKeyIndex
          });
          if(nextIndex == -1) {
            this.nowKeyIndex = noCompleteKeys[0];
            needLoop = false;
          }else{
            this.nowKeyIndex = noCompleteKeys[nextIndex];
          }
        }
      }
    }
    if (!this.isEnd) {
      const obj = dimensionKeys[this.nowKeyIndex];
      this.onDimensionClick(null, obj.key, needLoop, this.nowKeyIndex, false);
      if (!needLoop) viewModel.validate();
    }
    this.setState({ dimensionKeys })
  }

  async onDimensionClick (e, key, bLoopSave, dIndex, bSetCache) {
    const { groupCode, viewModel, addData, dimensionKeys, groupTaskKey } = this.state;
    this.setState({ navActive: dIndex });
    let vouchData = null;
    if (dimensionKeys[this.nowKeyIndex] && bSetCache) {
      this.setCacheData(dimensionKeys, viewModel, this.nowKeyIndex);
    }
    if (dimensionKeys[dIndex].cacheData) {
      vouchData = dimensionKeys[dIndex].cacheData
    } else {
      const config = {
        url: 'makeBill/getDimensionData',
        method: 'POST',
        options: { token: true },
        params: { groupCode: groupCode, dimensionKey: key, groupTaskKey }
      };
      const json = await proxy(config);
      if (json.code !== 200) {
        cb.utils.alert('获取dimension失败:' + json.message, 'error');
        return;
      }
      vouchData = json.data;
      vouchData.dimensionKey = key;
    }
    viewModel.clear();
    const data = Object.assign({}, addData, vouchData);
    viewModel.biz.do('render', viewModel, { data: data, dirty: true });
    viewModel.validate(true);
    this.nowKeyIndex = dIndex;
    if (bLoopSave) this.loopSave();
  }

  onModalOk = (para) => {
    if (this.isEnd == true) {
      const { dimensionKeys, groupCode, viewModel, addData } = this.state;
      const newKeys = [];
      dimensionKeys.map(obj => {
        if (!obj.isComplete)
          newKeys.push(obj);
      });
      if (newKeys.length > 0 && this.isTest == false) {
        viewModel.clear();
        viewModel.biz.do('render', viewModel, { data: Object.assign({}, addData, newKeys[0].cacheData), dirty: true });
        viewModel.validate(true);
        this.nowKeyIndex = 0;
        this.isEnd = false;
        this.setState({ showModal: false, dimensionKeys: newKeys })
      } else {
        this.goBack(groupCode, viewModel, true);
      }
      viewModel.setCache('isHideAlert', false);
    }
  }

  onModalClose = () => {
    this.setState({ showModal: false });
    if(this.isEnd && this.checkReturn()) this.state.viewModel.communication({ type: 'return'});
  }

  checkReturn=() => {
    const dimensionKeys = this.state.dimensionKeys;
    let bReturn = true;
    dimensionKeys && dimensionKeys.map(data => {
      if(data.errInfo && !cb.utils.isEmpty(data.errInfo.message))
        bReturn = false;
    });
    return bReturn;
  }

  consoleLog (str, bError) {
    // if (bError)
    console.log(str);
  }

  async goBack (groupCode, viewModel, bOK) {
    const { groupTaskKey } = this.state;
    const config = {
      url: 'makeBill/clearDimensionCache',
      method: 'POST',
      options: { token: true },
      params: { groupCode: groupCode, groupTaskKey }
    };
    const json = await proxy(config);
    if (json.code !== 200)
      this.consoleLog('clearDimensionCache失败: json.message = ' + json.message)
    else
      this.consoleLog('clearDimensionCache成功:groupCode = ' + groupCode)
    if (bOK) {
      cb.utils.alert('生单操作完毕。', 'success');
    }
    viewModel.communication({ type: 'return' });
  }

  onDelDimension = (e, index) => {
    const { dimensionKeys, groupCode, viewModel } = this.state;
    dimensionKeys.splice(index, 1);
    e.preventDefault();
    e.stopPropagation();
    if (dimensionKeys.length > 0) {
      index = (index == 0 ? 0 : index - 1);
      const obj = dimensionKeys[index];
      this.state.dimensionKeys = dimensionKeys;
      this.onDimensionClick(null, obj.key, false, index, false);
      this.setState({ dimensionKeys });
    }
    else {
      this.goBack(groupCode, viewModel, false);
    }
  }

  getDimensionControl = () => {
    const { dimensionKeys, focusRowIndex, navActive } = this.state;
    const controls = [];
    dimensionKeys.forEach((obj, index) => {
      if (!obj.isComplete)
        controls.push(
          <li
            onMouseEnter={e => this.onMouseEnter(e, index)}
            onMouseLeave={e => this.onMouseEnter(e, -1)}
            onClick={e => this.onDimensionClick(e, obj.key, false, index, true)}
            className={navActive == index ? 'active' : ''}
          >
            <span className='name'>{obj.name}</span>
            {focusRowIndex == index ? <span onClick={e => this.onDelDimension(e, index)} className='action'><Icon type='close' /></span> : null}
          </li>
        )
    });
    return <ul className='dimension-list'>{controls}</ul>
  }

  componentWillUnmount () {
    this.props.viewModel && this.props.viewModel.setCache('isInWorkBench', false);
  }

  render () {
    const self = this;
    const { viewModel, meta, width, height, index } = this.props;
    const { groupCode } = this.state;
    const dimensionControl = this.getDimensionControl();
    return (
      <Row className='workbench-container' colCount={4}>
        <div className='list-top-toolbar'>
          <Row>
            <div style={{ float: 'left' }}>
              <Row className='btn-toolbar-bottom' flex='start'>
                <Button onClick={e => self.goBack(groupCode, viewModel, false)}><SvgIcon className='icon-rollback' type='rollback' />返回</Button>
              </Row>
            </div>
            <div style={{ float: 'right' }}>
              <Row className='btn-toolbar-bottom' flex='end'>
                <Button onClick={this.saveAll}>保存全部</Button>
              </Row>
            </div>
          </Row>
        </div>
        <div className='workbench-main'>
          <div className='workbench-left'>{dimensionControl}</div>
          <div className='workbench-right'>
            <Container className='height-100' meta={meta}
              viewModel={viewModel} width={width ? width - 300 : 1024}
              height={height} index={index} />
          </div>
        </div>
        <BatchMsg
          type={1}
          msgArr={this.state.dimensionKeys}
          visible={this.state.showModal}
          handleOk={this.onModalOk}
          close={this.onModalClose}
          bCanClose={true}
          codeField='code'
        // bWhole={true}
        // dataType="voucher"
        />
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/Workbench.jsx